import { doResearchOnlineRegex } from "./constants";

const skipEmptyVerification = lineText => {
  return doResearchOnlineRegex.test(lineText);
};

export default skipEmptyVerification;
